import { Box, Container } from '@mui/material';
import PageHeader from 'components/common/PageHeader/PageHeader';
import StoreOrdersTable from 'components/tables/StoreOrdersTable/StoreOrdersTable';
import useGlobalStyles from 'styles/globalStyles';


export default function StoreOrdersPage() {
  const globalStyles = useGlobalStyles();

  return (
    <Box className={globalStyles.container}>
      <Container
        maxWidth={'xl'}
        className={globalStyles.container}
      >
        <Box pt={2}>
          <PageHeader
            title={'Store Orders'}
            buttons={[]}
          />
        </Box>

        <Box mt={3}>
          <StoreOrdersTable />
        </Box>
      </Container>
    </Box>
  )
}
